// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"e72bd28e","101":"0ce256b6","269":"8053f496","357":"7c5874fb","447":"8525b45c","549":"37a06bb8","723":"e7b48337","730":"85e78a73","731":"093bd734","845":"c1de3ef8"}[chunkId] + ".chunk.js";
};